import clsx from "clsx"
import React, { useEffect, useState } from "react"

interface CardProps {
	front: React.ReactElement
	back?: React.ReactElement
	cardKey: any
	onClick?: any
	cardStatus?: any
}

const Card: React.FC<CardProps> = ({ front, back = null, cardKey, onClick, cardStatus }) => {
	const [isCardFlipped, setIsCardFlipped] = useState<boolean>(false)

	useEffect(() => {
		if (back) {
			setTimeout(triggerFlipAnimation, 2000)
		}

		// eslint-disable-next-line
	}, [])

	useEffect(() => {
		if (cardStatus) {
			triggerFlipAnimation()
		}

		// eslint-disable-next-line
	}, [cardStatus])

	function triggerFlipAnimation() {
		setIsCardFlipped(true)
	}

	return (
		<section className={"cardShadow relative pb-[100%]"} onClick={onClick}>
			<div className={clsx("card", isCardFlipped && "carFlipped")} data-key={cardKey} style={{ transformStyle: "preserve-3d" }}>
				<div className="cardFace cardFaceFront">{front}</div>
				{cardStatus && cardStatus.loseCardIndex && (
					<div className="cardFace cardFaceBack">
						<img src={"images/memory/lose-" + cardStatus.loseCardIndex + ".png"} alt={"Card Index " + cardStatus.loseCardIndex} draggable="false" />
					</div>
				)}
				{cardStatus && cardStatus.winCardIndex && (
					<div className="cardFace cardFaceBack">
						<img src={"images/providers/" + cardStatus.winCardIndex + "-tile.png"} alt={cardStatus.winCardIndex} draggable="false" />
					</div>
				)}
				{back && <div className="cardFace cardFaceBack">{back}</div>}
			</div>
		</section>
	)
}
export default Card
